module.exports = __webpack_public_path__ + "img/share-arrow.2f51fb07.svg";